"use strict";
const $ = require("jquery");
// You can also use 'jQuery' if you prefer:
// const jQuery = require('jquery');

// If you need jQuery to be available globally (e.g., for older plugins or scripts
// that expect window.$ or window.jQuery), you can also add:
window.$ = $;
window.jQuery = $; // or window.jQuery = jQuery if you used that variable name

(($) => {
  let plus;
  const _ = require("underscore");
  let plusApp = {
    formatNr: (x, addComma) => {
      x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "&nbsp;");
      x = x.replace(".", ",");
      if (addComma === true && x.indexOf(",") === -1) {
        x = x + ",0";
      }
      return x === "" ? 0 : x;
    },
    roundNr: (x, d) => {
      return parseFloat(x.toFixed(d));
    },
    setPath: () => {
      if (location.href.match("dev")) {
        plusApp.path = "//dev.yle.fi/2017/" + plusApp.projectName + "/public/";
      } else if (location.href.match("yle.fi/plus")) {
        plusApp.path = "//yle.fi/plus/yle/2017/" + plusApp.projectName + "/";
      } else {
        plusApp.path = "//plus.yle.fi/" + plusApp.projectName + "/";
      }
    },
    getScale: () => {
      let width = plus.width();
      if (width >= 600) {
        plus.addClass("wide");
        return true;
      }
      if (width < 600) {
        plus.removeClass("wide");
        return false;
      }
    },
    initMediaUrls: () => {
      $.each($(".handle_img", plus), (i, el) => {
        $(this).attr("src", plusApp.path + "img/" + $(this).attr("data-src"));
      });
    },
    isViewed: (obj) => {
      const elementTop = obj.offsetTop;
      const windowOffset = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const elementHeight = obj.offsetHeight;
      const scrollBottom = windowOffset + windowHeight;
      return (
        scrollBottom - windowHeight / 3 > elementTop &&
        scrollBottom - windowHeight - elementHeight < elementTop
      );
    },
    getData: () => {
      $.getJSON(plusApp.path + "data/data.json", (data) => {
        plusApp.printData(data);
      });
    },
    printData: (data) => {
      $(".container", plus).html(
        plusApp.template({
          elements: data.elements,
          path: plusApp.path,
        })
      );
    },
    handleScroll: () => {
      $.each($(".play_on_scroll", plus), (i, el) => {
        if (plusApp.isViewed(el) === true) {
          $(el).removeClass("play_on_scroll");
          setTimeout(() => {
            el.play();
          }, 1000);
        } else {
          el.pause();
        }
      });
    },
    initEvents: () => {
      $(window).on("resize", plusApp.getScale);
      $(window).on("scroll", plusApp.handleScroll);

      plus.on("click", ".facebook_link", function () {
        const url = encodeURIComponent(document.location.href.split("#")[0]);
        const specs =
          "top=" +
          (screen.height / 2 - 420 / 2) +
          ",left=" +
          (screen.width / 2 - 550 / 2) +
          ",toolbar=0,status=0,width=550,height=420";
        window.open($(this).data("url") + url, "Jaa", specs);
      });
      plus.on("click", ".twitter_link", function () {
        const url = encodeURIComponent(document.location.href.split("#")[0]);
        const specs =
          "top=" +
          (screen.height / 2 - 420 / 2) +
          ",left=" +
          (screen.width / 2 - 550 / 2) +
          ",toolbar=0,status=0,width=550,height=420";
        window.open(
          $(this).data("url") +
            url +
            "&text=" +
            encodeURIComponent(
              "Suomen uusi kansallispuisto Hossa kertoo esi-isien eloonjäämistaistelusta. #Hossa"
            ),
          "Jaa",
          specs
        );
      });
    },
    unmount: () => {
      $(window).off("resize", plusApp.getScale);
      $(window).off("scroll", plusApp.handleScroll);
      if (plus !== undefined) {
        plus.unbind();
      }
      delete window.plusApp[plusApp.projectName];
    },
    mount: () => {
      plusApp.init();
      plusApp.isInitialized = true;
    },
    init: () => {
      plus = $(".plus-app.plus-app-" + plusApp.projectName);
      plusApp.setPath();
      plusApp.getScale();
      plusApp.initMediaUrls();
      plusApp.initEvents();

      // Store underscore templates.
      plusApp.template = _.template($(".template").html());

      plusApp.getData();
    },
    meta: {
      version: "1.0.0",
    },
  };
  plusApp.projectName = "2017-06-hossa";
  if (window.plusApp === undefined) {
    window.plusApp = {};
  }
  if (window.plusApp[plusApp.projectName] === undefined) {
    window.plusApp[plusApp.projectName] = plusApp;
    window.plusApp[plusApp.projectName].mount();
  }
})(jQuery);
